import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root'))

// Auto-detect basename for /hostedbb/ deployment
const basename = window.location.pathname.startsWith('/hostedbb/') ? '/hostedbb' : undefined

root.render(
  <BrowserRouter basename={basename}>
    <App />
  </BrowserRouter>
)
